// Render Prop
import React, { useState } from 'react'
import { randomInt } from './constants'
//import MongoContext from './MongoContext'
import { mongodb, client, useAuth } from './Auth/use-auth'
import Button from '@material-ui/core/Button'
import TextField from '@material-ui/core/TextField'
import CssBaseline from '@material-ui/core/CssBaseline'
import { makeStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
//import Link from '@material-ui/core/Link'
//import Typography from '@material-ui/core/Typography'
import DialogTitle from '@material-ui/core/DialogTitle'
import Grid from '@material-ui/core/Grid'
//import Slide from '@material-ui/core/Slide'
import { useParams } from 'react-router-dom'

import { useFormik } from 'formik'
//import { TextField } from 'formik-material-ui'
const useStyles = makeStyles(theme => ({
  appBar: {
    position: 'relative'
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto'
    }
  },
  paper: {
    width: 'auto',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      width: 600,
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3)
    }
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
    color: theme.palette.primary.dark
  }
}))

export default function InsertCar (props) {
  const classes = useStyles()
  const { auth } = useAuth()
  const [open, setOpen] = useState(true)
  const { field, id } = useParams()
  const db = mongodb.db('silmandDB')
  // const handleClickOpen = () => {
  //   setOpen(true)
  // }
  // Pass the useFormik() hook initial form values and a submit function that will
  // be called when the form is submitted textTransform: 'uppercase'
  const formik = useFormik({
    initialValues: {
      aliasName: '',
      carNr: '',
      carModel: '',
      carOdo: '',
      driverInfo: '',
      carHistory: ''
    },
    onSubmit: values => {
      //alert(JSON.stringify(values, null, 2))
      console.log('value andmed', JSON.stringify(values, null, 2))
      addCar(values)
    }
  })
  const addCar = async values => {
    //  if (props.match.params == 'insert') {
    try {
      await db.collection('clientCars').insertOne({
        _id: parseInt(randomInt(0, 9)),
        clientId: Number(id),
        owner_id: client.auth.user.id,
        aliasName: values.aliasName,
        carNr: values.carNr,
        carModel: values.carModel,
        carOdo: values.carOdo,
        driverInfo: values.driverInfo,
        carHistory: values.carHistory
      })
    } catch (e) {
      console.log('item find viga', e)
    } finally {
      props.history.go(-1)
    }
  }
  // const handleClose = e => {
  //   e.preventDefault()
  //   console.dir(e.target)
  //   console.log('value andmed', formik.aliasName)

  // setOpen(false)
  // props.history.go(-1)
  // }
  const handleCancel = () => {
    setOpen(false)
    props.history.go(-1)
  }
  return (
    <React.Fragment>
      <CssBaseline />
      <main className={classes.layout}>
        <Paper className={classes.paper}>
          <DialogTitle id='form-dialog-title'>Lisa autod {field} </DialogTitle>
          <form onSubmit={formik.handleSubmit}>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant='outlined'
                id='aliasName'
                name='aliasName'
                label='Nimetus'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.aliasName}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant='outlined'
                margin='dense'
                id='carNr'
                name='carNr'
                label='Reg Nr'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carNr.toUpperCase()}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant='outlined'
                margin='dense'
                id='carModel'
                label='Auto Mark'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carModel}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant='outlined'
                margin='dense'
                id='carOdo'
                label='Odomeeter'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carOdo}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant='outlined'
                multiline
                rows={3}
                margin='dense'
                id='driverInfo'
                label='Juhi Info'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.driverInfo}
              />
            </Grid>
            <Grid item xs={12} sm={12}>
              <TextField
                fullWidth
                variant='outlined'
                multiline
                rows={6}
                margin='dense'
                id='carHistory'
                label='Auto ajalugu'
                type='text'
                onChange={formik.handleChange}
                value={formik.values.carHistory}
              />
            </Grid>
            <div className={classes.buttons}>
              <Button type='submit' className={classes.button}>
                Lisa
              </Button>
              <Button onClick={handleCancel} className={classes.button}>
                Tagasi
              </Button>
            </div>
          </form>
        </Paper>
      </main>
    </React.Fragment>
  )
}
